export class SampleSupplierDto {
  id: string;
  label: string;
  fileNumber: string;
  sampleVersion: string;
  address: string;
  address1: string;
  city: string;
  country: string;
  email: string;
  telephone: string;
  comment: string;
}